if (!window.send) {
  window.send = (name, payload, from) => {
    if (from === void 0) {
      from = document;
    }
    from.dispatchEvent(
      new CustomEvent(name, {
        detail: payload,
        bubbles: true
      })
    );
  };
}
if (!window.checkNavigationAllowed) {
  window.checkNavigationAllowed = ({ newURL, oldURL = window.location.href, allow = false }) => {
    const payload = { ok: true, allow, oldURL, newURL };
    send("beforenavigate", payload, window);
    return allow || payload.ok;
  };
}
if (!window.navigate) {
  window.navigate = ({ to, id, params, allow = false }) => {
    const url = constructURL({ to, id, params });
    if (!checkNavigationAllowed({ allow, newURL: url })) {
      return;
    }
    if (url.includes(":")) {
      window.location.href = url;
    } else {
      window.location.hash = url;
    }
  };
}
if (!window.constructURL) {
  window.constructURL = ({ to, id, params }) => {
    const newTo = to != null ? to : getNavigationHash();
    let newId = id ? `/${id}` : "";
    if (!to && !id && params) {
      const previousId = getNavigationId();
      newId = previousId ? `/${previousId}` : "";
    }
    const newParams = params ? `?${new URLSearchParams(params).toString()}` : "";
    return `${newTo}${newId}${newParams}`;
  };
}
if (!window.getNavigationHash) {
  window.getNavigationHash = () => window.location.hash.split("?")[0].split("/")[0].substring(1);
}
if (!window.getNavigationId) {
  window.getNavigationId = () => window.location.hash.split("?")[0].split("/")[1];
}
if (!window.getNavigationParams) {
  window.getNavigationParams = () => new URLSearchParams(window.location.hash.split("?")[1]);
}
if (!window.setNavigationParams) {
  window.setNavigationParams = (queryParamsString) => {
    const baseUrl = location.origin + location.pathname + location.search;
    const navigationId = getNavigationId();
    const navigationHash = getNavigationHash() + (navigationId ? `/${navigationId}` : "");
    const url = `${baseUrl}#${navigationHash}?${queryParamsString}`;
    history.replaceState(null, null, url);
  };
}
if (!window.shortenFilename) {
  window.shortenFilename = (path, maxLength) => {
    const tmp = isEmpty(path) ? "" : path.substring(path.lastIndexOf("/") + 1);
    if (maxLength !== void 0 && tmp.length > maxLength) {
      const halfLength = Math.floor(maxLength / 2) - 1;
      return `${tmp.substring(0, halfLength)}...${tmp.substring(tmp.length - halfLength)}`;
    } else {
      return tmp;
    }
  };
}
if (!window.toValidFilename) {
  window.toValidFilename = (text, extension) => {
    let parsed = text;
    parsed = parsed.replaceAll(/[/\\:*?"<>|.]/g, "");
    parsed = parsed.replaceAll(/\s+/g, " ");
    return isEmpty(extension) ? parsed : `${parsed}.${extension}`;
  };
}
if (!window.download) {
  window.download = (filename, content) => {
    let url;
    if (typeof content === "string") {
      url = `data:text/plain;charset=utf-8,${window.encodeURIComponent(content)}`;
    } else {
      url = window.URL.createObjectURL(content);
    }
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
}
if (!window.formatFileSize) {
  window.formatFileSize = (size) => {
    const units = ["B", "KB", "MB", "GB", "TB"];
    const base = 1e3;
    let i = 0;
    while (size >= base && i < units.length - 1) {
      size /= base;
      i++;
    }
    return size.toFixed(2) + units[i];
  };
}
if (!window.formatDate) {
  window.formatDate = (date) => new Date(date).toLocaleDateString("de-ch", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
}
if (!window.formatDateTime) {
  window.formatDateTime = (datetime) => new Date(datetime).toLocaleDateString("de-ch", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
}
if (!window.isEmpty) {
  window.isEmpty = (str) => str === void 0 || str === null || str === "";
}
if (!window.setAlerts) {
  window.setAlerts = (alerts) => window.alerts = alerts;
}
if (!window.showAlert) {
  window.showAlert = (title, message, type, reasons) => {
    if (!window.alerts) {
      setAlerts([]);
    }
    window.alerts.push({ title, text: message, type, reasons });
    send("isceco-alert-happend");
  };
}
if (!window.setLanguage) {
  window.setLanguage = (lang) => {
    localStorage.setItem(`${window.iscecoWidgetLibrary.languageKey}-language`, lang);
  };
}
if (!window.getLanguage) {
  window.getLanguage = () => {
    let lang = localStorage.getItem(`${window.iscecoWidgetLibrary.languageKey}-language`);
    if (!lang) {
      lang = navigator.language || navigator.userLanguage;
      lang = lang.substring(0, 2);
      if (window.iscecoWidgetLibrary.supportedLanguages.indexOf(lang) < 0) {
        lang = window.iscecoWidgetLibrary.supportedLanguages[0];
      }
    }
    return lang;
  };
}
if (!window.translateText) {
  window.translateText = (translations, key, args) => {
    const text = translations[getLanguage()][key];
    if (text instanceof Function) {
      return text(args);
    } else {
      return text;
    }
  };
}
if (!window.hasRole) {
  window.hasRole = (roleName) => {
    var _a, _b;
    if ((_a = window.keycloak) == null ? void 0 : _a.tokenParsed.role) {
      return ((_b = window.keycloak) == null ? void 0 : _b.tokenParsed.role.indexOf(roleName)) >= 0;
    }
    return false;
  };
}
if (!window.scrollToTop) {
  window.scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
}
if (!window.keycloak) {
  window.keycloak = null;
}
